import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, getCurrentInstance } from 'vue';
import CountryRepository from '@/repositories/CountryRepository';

interface Props {
    poNumber: any;
    city: any;
    country: any;
    countries: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AddressLocationFields',
  props: {
    poNumber: null,
    city: null,
    country: null,
    countries: null
  },
  emits: ["update:poNumber", "update:city", "update:country", "update:languageCode", "update:printRegion"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'update:poNumber', value: string): void;
    (e: 'update:city', value: string): void;
    (e: 'update:country', value: string): void;
    (e: 'update:languageCode', value: string): void;
    (e: 'update:printRegion', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    poNumber: any;
    city: any;
    country: any;
    countries: any[];
};





// Template refs for validation border styling
const addressPoNumber = ref<HTMLElement | null>(null);
const addressCity = ref<HTMLElement | null>(null);
const country = ref<HTMLElement | null>(null);

// Expose refs for parent component access
expose({
    addressPoNumber,
    addressCity,
    country,   
});

const proxy = getCurrentInstance()?.proxy as any;

const getCountryById = (countryId: string) => {
  return props.countries.find(c => c.id === countryId);
};

const selectedCountryValue = computed(() => {
    if (!props.country) return '';

    // If already in format "id|code", return as is
    if (props.country.includes('|')) {
        return props.country;
    }

    // Otherwise, look up the country and format it
    const countryObj = getCountryById(props.country);
    return countryObj ? `${countryObj.id}|${countryObj.code}` : '';
});

const flagUrl = computed(() => {
    const code = selectedCountryValue.value.split('|')[1];
    return code ? `url(https://flagsapi.com/${code}/flat/32.png)` : '';
});

const sanitize = (val: any) => {
  if (val === null || val === undefined || val === 'null') return '';
  return val;
};

const onSelectedCountryChange = (value: string) => {
//   const countryId = value.split('|')[0];
//   emit('update:country', countryId);
//   const countryObj = CountryRepository.getById(countryId);
  
//   if (countryObj) {
//     emit('update:languageCode', sanitize(countryObj.languageCode));
//     emit('update:printRegion', sanitize(countryObj.printRegion));
//   }
};

return { __sfc: true,props, emit, addressPoNumber, addressCity, country, proxy, getCountryById, selectedCountryValue, flagUrl, sanitize, onSelectedCountryChange }
}

})